import { DatePicker, Input, InputNumber } from 'antd'
import React from 'react'
import { useSubmittalTrackerContext } from '../../../../../../SubmittalTrackerContext'
import { Submittal } from '../../../../../../SubmittalTrackerContext/types'
import CIMSSelect from 'components/CIMSSelect'
import CIMSFormItem from 'components/CIMSFormItem'

export const RouterReview: React.FC<Partial<Submittal>> = ({
  packageName,
  packageNumber,
}) => {
  const {
    selectOptions: { typeOptions, subtypeOptions },
  } = useSubmittalTrackerContext()
  return (
    <>
      <CIMSFormItem
        label="Package Number"
        disabled={{
          disabled: true,
          reason: {
            why: 'disabled',
            message: 'Cannot be edited in this dialog',
          },
        }}
      >
        <Input disabled defaultValue={packageNumber} />
      </CIMSFormItem>
      <CIMSFormItem
        label="Package Name"
        disabled={{
          disabled: true,
          reason: {
            why: 'disabled',
            message: 'Cannot be edited in this dialog',
          },
        }}
      >
        <Input disabled defaultValue={packageName} />
      </CIMSFormItem>
      <CIMSFormItem
        label="Requested Review Date"
        name="requestedReviewDate"
        requiredMessage="Please enter a requested review date"
      >
        <DatePicker />
      </CIMSFormItem>
      <CIMSFormItem
        label="Type"
        name="type"
        requiredMessage="Please select a type"
      >
        <CIMSSelect options={typeOptions} />
      </CIMSFormItem>
      <CIMSFormItem label="Subtype" name="subtype">
        <CIMSSelect options={subtypeOptions} />
      </CIMSFormItem>
      <CIMSFormItem
        label="Quantity"
        name="quantity"
        requiredMessage="Please enter a quantity"
      >
        <InputNumber type="number" />
      </CIMSFormItem>
      <CIMSFormItem
        label="Units"
        name="units"
        requiredMessage="Please enter units"
      >
        <Input />
      </CIMSFormItem>
    </>
  )
}
